let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bNqeG")).then(() => parcelRequire('Xu9Uw'));